<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
  <path d="M18 6A6 6 0 1 1 6 6a6 6 0 0 1 12 0Zm1.166 18c1.657 0 3.041-1.37 2.574-2.96a10.497 10.497 0 0 0-10.074-7.54 10.5 10.5 0 0 0-10.074 7.54C1.125 22.63 2.509 24 4.166 24h15Z"/>
</svg>
